(function () {
  'use strict';

  if (window.__gizetCheckoutOnDemand) return;
  window.__gizetCheckoutOnDemand = true;

  var state = 'idle';
  var queue = [];
  var loaderUrl = document.currentScript && document.currentScript.src
    ? document.currentScript.src
    : '';
  var SCRIPT_URL = loaderUrl
    ? loaderUrl.replace(/gizet-checkout-loader\.js(?:\?.*)?$/, 'gizet-onepage-checkout-local.js?v=20260728-mobile-direct-1')
    : '/cdn/shop/files/gizet-onepage-checkout-local.js?v=20260728-mobile-direct-1';

  function getControl(target) {
    if (target && target.nodeType === 3) target = target.parentElement;
    return target && target.closest
      ? target.closest('a, button, input[type="submit"], input[type="button"], [role="button"]')
      : null;
  }

  function isCheckoutControl(control) {
    if (!control || control.closest('.gz-modal')) return false;
    var name = String(control.getAttribute('name') || '').toLowerCase();
    var id = String(control.id || '').toLowerCase();
    var classes = String(control.className || '').toLowerCase();
    var href = String(control.getAttribute('href') || '').toLowerCase();

    return control.classList.contains('gizet-order-now')
      || name === 'checkout'
      || id === 'checkout'
      || classes.indexOf('cart__checkout-button') !== -1
      || control.hasAttribute('data-checkout')
      || control.hasAttribute('data-cart-checkout')
      || href === '/checkout'
      || href.indexOf('/checkout?') === 0;
  }

  function closeCartDrawer(control, done) {
    var drawer = control && control.closest
      ? control.closest('cart-drawer-component')
      : null;
    var dialog = drawer && drawer.querySelector
      ? drawer.querySelector('dialog')
      : null;

    if (!drawer || !dialog || !dialog.open) {
      done();
      return;
    }

    try {
      if (typeof drawer.closeDialog === 'function') {
        Promise.resolve(drawer.closeDialog()).then(done, function () {
          if (dialog.open && typeof dialog.close === 'function') dialog.close();
          done();
        });
        return;
      }

      if (typeof drawer.close === 'function') drawer.close();
      if (dialog.open && typeof dialog.close === 'function') dialog.close();
    } catch (error) {
      if (dialog.open && typeof dialog.close === 'function') dialog.close();
    }

    done();
  }

  function openControl(control) {
    closeCartDrawer(control, function () {
      if (!window.GizetCheckout) {
        window.alert('Gizet checkout could not start. Please refresh and try again.');
        return;
      }

      if (control.classList.contains('gizet-order-now')) {
        window.GizetCheckout.openProduct(control);
        return;
      }

      window.GizetCheckout.openCart();
    });
  }

  function flush(error) {
    var pending = queue.slice();
    queue.length = 0;
    pending.forEach(function (control) {
      if (error || !control || !document.documentElement.contains(control)) return;
      openControl(control);
    });
  }

  function load() {
    if (state === 'loading' || state === 'ready') return;
    state = 'loading';

    var script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.async = true;
    script.onload = function () {
      state = 'ready';
      flush();
    };
    script.onerror = function () {
      state = 'error';
      flush(new Error('Checkout failed to load'));
      window.alert('Gizet checkout could not load. Please refresh and try again.');
    };
    document.head.appendChild(script);
  }

  document.addEventListener('click', function (event) {
    var control = getControl(event.target);
    if (!isCheckoutControl(control)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (state === 'ready') {
      openControl(control);
      return;
    }

    queue = [control];
    load();
  }, true);

  document.addEventListener('submit', function (event) {
    var control = event.submitter;
    if (!isCheckoutControl(control)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (state === 'ready') {
      if (control) openControl(control);
      return;
    }

    if (control) queue = [control];
    load();
  }, true);

  load();
})();
